import React, { ReactNode } from "react"
import {
  Box,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  Text as ChakraText,
} from "@chakra-ui/react"
import Select, { SelectOption } from "components/Select"

export enum FixedBlockInputType {
  Text,
  Date,
  Dropdown,
}

type Props = {
  name: string
  required?: boolean
  placeholder?: string
  inputRightElement?: ReactNode
  type?: FixedBlockInputType
}

const FixedBlockInput = ({
  name,
  required,
  placeholder,
  inputRightElement,
  type = FixedBlockInputType.Text,
}: Props) => {
  const label = (
    <Flex mb={1.5}>
      <ChakraText fontSize="sm" fontWeight="semibold">{name}</ChakraText>
      {required && (
        <ChakraText fontSize="sm" fontWeight="semibold" color="red.600">
          &nbsp;*
        </ChakraText>
      )}
    </Flex>
  )

  if (type === FixedBlockInputType.Dropdown) {
    // Non-interactive preview of the dropdown the guest sees.
    return (
      <Box mb={1}>
        {label}
        <Box pointerEvents="none">
          <Select<SelectOption, false>
            placeholder={placeholder || "Select..."}
            options={[]}
            menuIsOpen={false}
            isSearchable={false}
            tabIndex={-1}
          />
        </Box>
      </Box>
    )
  }

  return (
    <Box mb={1}>
      {label}
      <InputGroup>
        {type === FixedBlockInputType.Text ? (
          <Input
            variant="outline"
            type="text"
            isRequired={required}
            isReadOnly
            placeholder={placeholder}
          />
        ) : (
          <Input
            w="35%"
            variant="outline"
            type="date"
            isRequired={required}
            placeholder={placeholder}
          />
        )}
        {inputRightElement && (
          <InputRightElement>
            {inputRightElement}
          </InputRightElement>
        )}
      </InputGroup>
    </Box>
  )
}

export default FixedBlockInput
